import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import Login from './Login';
import DEAAnalysis from './components/DEAAnalysis';
import DatasetInput from './components/DatasetInput';
import UserManual from './components/UserManual'; // <--- IMPORT THIS
import { printHandout } from './printHandout';

function App() {
  const [session, setSession] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showManual, setShowManual] = useState(false); // <--- NEW STATE

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <div className="App" style={{ fontFamily: 'Arial, sans-serif' }}>
      {!session ? (
        <Login />
      ) : (
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
          
          {/* HEADER SECTION */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
             <div style={{ display: 'flex', alignItems: 'center' }}>
              <a 
                href="https://nsb.ac.in" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
              >
                <img 
                  src="/nsb_logo.png" 
                  alt="NSB Logo" 
                  style={{ height: '60px', marginRight: '20px', cursor: 'pointer' }} 
                />
              </a>
              <h1 style={{ margin: 0 }}>DEA Analysis Tool</h1>
            </div>
            
            <div style={{ display: 'flex', gap: '10px' }}>
              {/* HELP BUTTON */}
              <button 
                onClick={() => setShowManual(true)}
                style={{
                  background: '#17a2b8', color: 'white', border: 'none',
                  padding: '8px 16px', borderRadius: '4px', cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                ? User Guide
              </button>
                <button 
                onClick={printHandout}
                style={{
                  background: '#28a745', color: 'white', border: 'none',
                  padding: '8px 16px', borderRadius: '4px', cursor: 'pointer',
                  fontWeight: 'bold', marginLeft: '10px'
                }}
              >
                📄 Download Handout
              </button>
              <button 
                onClick={() => supabase.auth.signOut()} 
                style={{ 
                  background: '#6c757d', color: 'white', border: 'none',
                  padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' 
                }}
              >
                Sign Out
              </button>
            </div>
          </div>

          <DatasetInput 
            user={session.user} 
            onUploadSuccess={() => setRefreshTrigger(prev => prev + 1)} 
          />

          <hr style={{ margin: '30px 0', border: '0', borderTop: '1px solid #eee' }} />

          <DEAAnalysis key={refreshTrigger} />

          {/* RENDER MANUAL MODAL */}
          {showManual && <UserManual onClose={() => setShowManual(false)} />}
          
        </div>
      )}
    </div>
  );
}

export default App;